import React from 'react';
import clsx from 'clsx';

import './index.scss';

const RadioInputWithIcon = ({ value, onChange, icon, checked, label, subLabel, id }) => {
  const svgDir = require.context("!@svgr/webpack!assets/");

  const Icon = svgDir(`./${icon}.svg`).default;

  // const DispIcon = () => {
  //   return (
  //     <span className="">
  //       <img className="icon" src={require(`assets/${icon}.svg`)} alt="" />
  //     </span>
  //   );
  // };

  return (
    <>
      <div className={clsx('RadioInputWithIcon', { checked })}>
        <div className='radio-input-wrapper'>
          <label htmlFor={id}>
            <span className="">
              <input
                className='radio-input'
                type="radio"
                value={value}
                onChange={onChange}
                checked={checked}
                id={id}
              />
            </span>
            <div className="iconArea">
              {/* <DispIcon /> */}
              <span className="icon">
                <Icon/>                
              </span>
            </div>
            <div className="RadioInputWithIcon.label">
              <span className="">
                {
                  Array.isArray(label)
                    ? label.map(line => (
                      (
                        <>
                          {line}
                          <br />
                        </>
                      )
                    ))
                    : 
                    label
                }
              </span>
              <span className="subLabel">
                {
                  Array.isArray(subLabel)
                    ? subLabel.map(line => (
                      (
                        <>
                          {line}
                          <br />
                        </>
                      )
                    ))
                    : 
                    subLabel
                }
              </span>

            </div>
          </label>
        </div>
      </div>
    </>
  );
};

export default RadioInputWithIcon;